import { useLang } from "../i18n/LanguageContext";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, FlaskConical, HeartHandshake } from "lucide-react";

const AboutPage = () => {
  const { t } = useLang();
  const values = [
    { icon: Sparkles, title: t("about.v1_title"), body: t("about.v1_body") },
    { icon: FlaskConical, title: t("about.v2_title"), body: t("about.v2_body") },
    { icon: HeartHandshake, title: t("about.v3_title"), body: t("about.v3_body") },
  ];

  return (
    <div data-testid="page-about" className="bg-white">
      <section className="container-flow section-pad">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <p className="text-overline">{t("about.overline")}</p>
            <h1 className="mt-4 hd-italic text-5xl md:text-7xl text-forest leading-[0.95]">{t("about.title")}</h1>
          </div>
          <div className="lg:col-span-5 lg:pt-8">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_b980f4aa-2a90-4c5a-b8ce-67c738c6deb7/artifacts/swg8ajoh_76F2F6A7-E05F-45F8-8882-F5492A22659D.jpeg"
                alt="Nageuse en piscine"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-bone section-pad">
        <div className="container-flow grid grid-cols-1 lg:grid-cols-12 gap-12">
          <aside className="lg:col-span-3">
            <p className="font-heading uppercase tracking-widest text-sm font-bold text-burnt">2025 — {new Date().getFullYear()}</p>
            <p className="font-heading italic text-3xl text-forest leading-tight mt-3">"Le sport est une histoire qu'on écrit chaque jour."</p>
          </aside>
          <div className="lg:col-span-9 space-y-6 text-lg text-forest/90 leading-relaxed">
            <p data-testid="about-p1" className="first-letter:text-7xl first-letter:font-heading first-letter:font-black first-letter:italic first-letter:text-burnt first-letter:mr-3 first-letter:float-left first-letter:leading-none">
              {t("about.p1")}
            </p>
            <p data-testid="about-p2">{t("about.p2")}</p>
            <p data-testid="about-p3">{t("about.p3")}</p>
            <p data-testid="about-p4">{t("about.p4")}</p>
            <p data-testid="about-p5">{t("about.p5")}</p>
          </div>
        </div>
      </section>

      <section className="bg-white section-pad">
        <div className="container-flow">
          <h2 className="hd-italic text-4xl md:text-5xl text-forest">{t("about.values_title")}</h2>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            {values.map((v, i) => {
              const Icon = v.icon;
              return (
                <div key={i} data-testid={`value-${i}`} className="border border-border p-10 hover:-translate-y-1 transition-transform">
                  <div className="w-12 h-12 bg-forest text-white flex items-center justify-center">
                    <Icon size={22} />
                  </div>
                  <h3 className="mt-6 hd-italic text-3xl text-forest">{v.title}</h3>
                  <p className="mt-3 text-muted-foreground leading-relaxed">{v.body}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-16 flex justify-center">
            <Link to="/reservation" className="btn-primary">
              {t("nav.book_cta")} <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
